import { Customer } from '~/lib/api/smartsend/types';
export const IsDefaultAddress = (customer: Customer) => customer.Meta['IsDefault']?.Value?.toLowerCase() === 'true';
export const IsBillingAddress = (customer: Customer) => customer.Meta['IsBilling']?.Value?.toLowerCase() === 'true';
